var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlusIconBordered(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M14.3588 0H5.6412C2.25586 0 0 2.4199 0 5.89317V14.1068C0 17.5833 2.24992 20 5.6412 20H14.3588C17.7501 20 20 17.5833 20 14.1068V5.89317C20 2.41665 17.7501 0 14.3588 0ZM5.6412 1.39535H14.3588C16.9563 1.39535 18.6047 3.16587 18.6047 5.89317V14.1068C18.6047 16.8341 16.9563 18.6047 14.3588 18.6047H5.6412C3.04372 18.6047 1.39535 16.8341 1.39535 14.1068V5.89317C1.39535 3.16949 3.04923 1.39535 5.6412 1.39535ZM10 5.88587C10.3532 5.88587 10.6451 6.14834 10.6913 6.48887L10.6977 6.58354V9.29347H13.4109C13.7962 9.29347 14.1085 9.60583 14.1085 9.99115C14.1085 10.3444 13.8461 10.6363 13.5055 10.6825L13.4109 10.6888H10.6977V13.3988C10.6977 13.7841 10.3853 14.0964 10 14.0964C9.64679 14.0964 9.35489 13.834 9.30869 13.4934L9.30233 13.3988V10.6888H6.58915C6.20383 10.6888 5.89147 10.3765 5.89147 9.99115C5.89147 9.63794 6.15394 9.34604 6.49448 9.29984L6.58915 9.29347H9.30233V6.58354C9.30233 6.19823 9.61469 5.88587 10 5.88587Z",
    fill: "currentColor",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlusIconBordered);
export default __webpack_public_path__ + "static/media/plus_icon_bordered.5a05df55a2e9b823e3a857b6e9378f0a.svg";
export { ForwardRef as ReactComponent };